if (!customElements.get('newsletter-subscription')) {
  class NewsletterSubscription extends HTMLElement {
    constructor() {
      super();

      this.mutationConfig = {
        childList: true,
        subtree: true,
      };

      this.emailValidationRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      this.isKlaviyoLoaded = false;

      this.klaviyoForm = this.querySelector('[data-klaviyo-form-id]');
      this.klaviyoFormID = this.klaviyoForm.dataset.klaviyoFormId;
      this.handleKlaviyoMutation = this.onKlaviyoMutation.bind(this);

      this.contactSuccessMessage = this.querySelector('[data-newsletter-form="success"]');
      this.subscriptiontForm = this.querySelector('[data-newsletter-form="form"]');

      this.formInputFirstName = this.subscriptiontForm.querySelector('[name="contact[first_name]"]');
      this.formInputLastName = this.subscriptiontForm.querySelector('[name="contact[last_name]"]');
      this.formInputEmail = this.subscriptiontForm.querySelector('[name="contact[email]"]');
      this.emailErrorWrapper = this.subscriptiontForm.querySelector('[id^="ContactForm-email-error-"]');

      this.handleFormSubmit = this.onFormSubmit.bind(this);
      this.handleConnectForm = this.onConnectForm.bind(this);
    }

    connectedCallback() {
      this.klaviyoObserver = new MutationObserver(this.handleKlaviyoMutation);
      this.klaviyoObserver.observe(this, this.mutationConfig);

      document.addEventListener('DOMContentLoaded', this.handleConnectForm);
      this.subscriptiontForm.addEventListener('submit', this.handleFormSubmit);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.handleConnectForm);
      this.subscriptiontForm.removeEventListener('submit', this.handleFormSubmit);
    }

    onConnectForm() {
      this.klaviyoForm.classList.add(`klaviyo-form-${this.klaviyoFormID}`)
    }

    onFormSubmit(event) {
      event.preventDefault();

      if (!this.isKlaviyoLoaded) return;

      if (!this._validateEmail(this.formInputEmail)) {
        this.emailErrorWrapper.setAttribute('aria-invalid', true);
        this.emailErrorWrapper.classList.remove('visually-hidden');

        return;
      }

      if (!this.formInputFirstName.value.trim().length) return;
      if (!this.formInputLastName.value.trim().length) return;

      this.emailErrorWrapper.removeAttribute('aria-invalid');
      this.emailErrorWrapper.classList.add('visually-hidden');

      const formFieldsValue = [
        this.formInputFirstName.value,
        this.formInputLastName.value,
        this.formInputEmail.value,
      ];

      this.submitKlaviyoForm(formFieldsValue)
    }

    _validateEmail(mail) {
      return this.emailValidationRegx.test(mail.value);
    }

    submitKlaviyoForm(formValues) {
      const submitButton = this.klaviyoForm.querySelector('button[type="button"]');

      const klaviyoFormElements = [
        this.klaviyoForm.querySelector('[id^="first_name"]'),
        this.klaviyoForm.querySelector('[id^="last_name"]'),
        this.klaviyoForm.querySelector('[id^="email"]'),
      ];

      klaviyoFormElements.forEach((elem, index) => {
        elem.value = formValues[index];
        elem.dispatchEvent(new Event('input', { bubbles: true }));
      });

      setTimeout( () => {
        submitButton.click();

        this.subscriptiontForm.reset();
        this.contactSuccessMessage.classList.remove('visually-hidden');
        this.subscriptiontForm.classList.add('visually-hidden');

      }, 0);
    }

    onKlaviyoMutation(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type !== 'childList') continue;
        this.isKlaviyoLoaded = true;

        this.klaviyoObserver.disconnect();
      }
    }
  }

  customElements.define('newsletter-subscription', NewsletterSubscription);
}
